import React from "react";

import { push } from "connected-react-router";
import { toast } from "react-toastify";
import { isEnabled } from "utils/featureFlags";

import moment from "moment";

import * as DatasetAPI from "api/DatasetAPI";

import { CHART_TYPES } from "containers/Report/ReportReducer";

import * as nextReducer from "containers/Next/NextReducer";
import * as homeReducer from "containers/Home/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";
import * as nextTransformReducer from "containers/Next/Transform/TransformReducer";
import * as viewReducer from "containers/View/reducer";

const UPDATE_FIELD = "nextOverview/UPDATE_FIELD";
const UPDATE_FIELD_VALUE = "nextOverview/UPDATE_FIELD_VALUE";
const UPDATE_HEX = "nextOverview/UPDATE_HEX";
const UPDATE_HOVER = "nextOverview/UPDATE_HOVER";

export const primaryColors = ["rgba(229, 176, 247, 1)", "rgba(137, 229, 246, 1)", "rgba(178, 226, 87, 1)"];
export const secondaryColors = ["rgba(241, 215, 250, 1)", "rgba(204, 245, 252, 1)", "rgba(216, 240, 164, 1)"];

const fakeHexMap = {
  ["8_8"]: [
    {
      type: "AIBLE",
      impact: 5780000,
      background: "rgba(76, 51, 115, 1)",
      color: "white"
    }
  ],
  ["8_9"]: [
    {
      type: "Marketing",
      impact: 1920000,
      background: "rgba(137, 229, 246, 1)",
      color: "#4B495B"
    },
    {
      type: "MarketingTest",
      impact: 5555555,
      background: "rgba(137, 229, 246, 1)",
      color: "#4B495B"
    }
  ]
};

const initialOverview = {
  hexMap: {},
  isLoading: true
};

function overviewReducer(state = initialOverview, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.nextOverview;
}

export function getHexMap(state) {
  return getBase(state).hexMap;
}

export function getActionHexMap(state) {
  return getBase(state).actionHexMap;
}

export function getSelectedHex(state) {
  return getBase(state).selectedHex;
}

export function getIsLoading(state) {
  return getBase(state).isLoading;
}

export function getNeighborLocation(x, y) {
  let secondItemY = 0;
  let thirdItemY = 1;
  let lastItemY = 0;

  if (x % 2 === 0) {
    secondItemY = -1;
    thirdItemY = 0;
    lastItemY = -1;
  }

  return {
    [0]: {
      x: x,
      y: y - 1
    },
    [1]: {
      x: x + 1,
      y: y + secondItemY
    },
    [2]: {
      x: x + 1,
      y: y + thirdItemY
    },
    [3]: {
      x: x,
      y: y + 1
    },
    [4]: {
      x: x - 1,
      y: y + thirdItemY
    },
    [5]: {
      x: x - 1,
      y: y + lastItemY
    }
  };
}

export function findNextNeighbor(state, x, y, hMap = undefined) {
  const hexMap = hMap ? hMap : getHexMap(state);

  const neighbors = getNeighborLocation(x, y);
  const nextNeighbor = Object.keys(neighbors).find((nKey) => {
    const nHex = neighbors[nKey];
    return hexMap[nHex.x + "_" + nHex.y] === undefined;
  });

  return neighbors[nextNeighbor];
}

export function updateIsLoading(isLoading) {
  return { type: UPDATE_FIELD, key: "isLoading", data: isLoading };
}

export function updateHexMap(hexMap) {
  return { type: UPDATE_FIELD, key: "hexMap", data: hexMap };
}

export function handleProjectClick(nextId, datasetId) {
  return (dispatch, getState) => {
    dispatch(push("/next/" + datasetId + "/" + nextId));
    dispatch(nextReducer.updateActiveTab(nextId, "MODELS"));
  };
}

export function init() {
  return (dispatch, getState) => {
    const isLoading = getIsLoading(getState());
    if (isLoading === false) {
      return Promise.resolve();
    }

    dispatch(nextModelsReducer.initAll());
    dispatch(nextTransformReducer.initAll());

    setTimeout(() => {
      Promise.all(
        Object.keys(projectReducer.getBase(getState())).map((projectId) => dispatch(projectReducer.init(projectId)))
      ).then((e) => {
        let hexMap = {
          ["8_8"]: [
            {
              type: "AIBLE",
              impact: 5780000,
              background: "rgba(76, 51, 115, 1)",
              color: "white"
            }
          ]
        };
        let centerHex = { x: 8, y: 8 };

        const projects = Object.keys(projectReducer.getBase(getState())).map((projectId) =>
          projectReducer.getProject(getState(), projectId)
        );

        console.log(projects);

        let datasets = {};

        projects.forEach((project) => {
          const runId = project?.settings?.runId;
          const datasetId = setupReducer.getDatasetId(getState(), runId);

          if (datasets[datasetId] === undefined) {
            datasets[datasetId] = true;
          }
        });

        console.log(datasets);

        let totalImpact = 0;

        Object.keys(datasets)
          .sort((a, b) => {
            const retProjectsA = projects.filter((project) => {
              const runId = project?.settings?.runId;
              return a === setupReducer.getDatasetId(getState(), runId);
            });

            const minA =
              retProjectsA.length === 0
                ? 0
                : retProjectsA.reduce(
                    (min, p) => (p.created_date < min ? p.created_date : min),
                    retProjectsA[0].created_date
                  );

            const retProjectsB = projects.filter((project) => {
              const runId = project?.settings?.runId;
              return b === setupReducer.getDatasetId(getState(), runId);
            });

            const minB =
              retProjectsB.length === 0
                ? 0
                : retProjectsB.reduce(
                    (min, p) => (p.created_date < min ? p.created_date : min),
                    retProjectsB[0].created_date
                  );

            console.log(minA);
            console.log(minB);

            return minA < minB ? -1 : minB > minA ? 1 : 0;
          })
          .forEach((datasetId, dIndex) => {
            const retProjects = projects.filter((project) => {
              const runId = project?.settings?.runId;
              return datasetId === setupReducer.getDatasetId(getState(), runId);
            });

            const nextNeighbor = findNextNeighbor(getState(), centerHex.x, centerHex.y, hexMap);

            console.log("nn", nextNeighbor);

            let firstNode = undefined;
            let nodes = [];

            retProjects.forEach((project, i) => {
              const runId = project?.settings?.runId;
              const dataset = homeReducer.getDataset(getState(), datasetId);

              const optimized = projectReducer.getOptimized(getState(), project.id);
              console.log(optimized);

              const node = {
                type: dataset?.label,
                impact: optimized?.profit,
                projectId: project.id,
                nextId: nextReducer.getNextIdFromProjectId(getState(), project.id),
                datasetId: datasetId,
                background:
                  i === 0
                    ? primaryColors[dIndex % primaryColors.length]
                    : secondaryColors[dIndex % secondaryColors.length],
                color: "#4B495B"
              };

              if (i === 0) {
                firstNode = node;
              } else {
                nodes.push({ ...node, opacity: 0.8 });
              }
            });

            if (nextNeighbor !== undefined) {
              if (firstNode !== undefined) {
                totalImpact += firstNode.impact;
                hexMap[nextNeighbor.x + "_" + nextNeighbor.y] = [firstNode];
              }

              if (nodes.length > 0) {
                const nNeighbor = findNextNeighbor(getState(), nextNeighbor.x, nextNeighbor.y, hexMap);
                console.log("next neighbor", nNeighbor);
                hexMap[nNeighbor.x + "_" + nNeighbor.y] = nodes;
              }
            }
          });

        // Danger
        hexMap["8_8"][0].impact = totalImpact;

        dispatch(updateHexMap(hexMap));
        dispatch(updateIsLoading(false));
      });
    }, 1000);
  };
}

export function checkSearchFilterDataset(search, dataset) {
  if (!search) {
    return true;
  }

  return (
    (dataset?.name && dataset?.name.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
    (dataset?.target && dataset?.target.toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
    (dataset?.id && (dataset?.id + "").toLowerCase().indexOf(search.toLowerCase()) !== -1) ||
    (dataset?.created_by?.fullname &&
      (dataset?.created_by?.fullname).toLowerCase().indexOf(search.toLowerCase()) !== -1)
  );
}

export function overviewSearch(overviewData) {
  return (dispatch, getState) => {
    if (!overviewData) {
      return;
    }
    const datasetList = viewReducer.getDatasetSearchResult(getState()) ?? [];
    const datasets = homeReducer.getDatasets(getState());

    const connectionSearch = {
      type: "SCHEMA_MONITOR",
      value: overviewData?.schema_monitor?.id
    };

    if (overviewData?.name === "CSV Upload" && overviewData?.source_type === "RAW_DATA") {
      connectionSearch.type = "CSV";
      connectionSearch.value = overviewData.source_type;
    } else if (overviewData?.source_type === "CONNECTION_METADATA" && overviewData?.name === "Cloud Storage Link") {
      connectionSearch.type = "CLOUD";
      connectionSearch.value = overviewData.source_type;
    }

    const validData = datasetList.filter((d) => {
      if (connectionSearch.type === "CSV") {
        return d?.source?.content?.type === connectionSearch.value;
      }
      if (connectionSearch.type === "CLOUD") {
        return (
          d?.source?.content?.schema_monitor_id === undefined && d?.source?.content?.type === connectionSearch.value
        );
      }

      return String(d?.source?.content?.schema_monitor_id) === String(connectionSearch.value);
    });

    const fetchData = validData.filter((d) => (datasets && datasets[d?.id] === undefined ? true : false));
    dispatch(viewReducer.updateConnectionSearch(connectionSearch));
    dispatch(viewReducer.updateSearchValue(overviewData?.name));
    dispatch(viewReducer.updateFetchingDatasetCount(fetchData.length));

    fetchData.forEach((d) => {
      dispatch(homeReducer.fetchDatasetWithoutDetails(d?.id)).then((fr) => {
        if (fr !== undefined) {
          dispatch(viewReducer.updateFetchingDatasetCount(viewReducer.getFetchingDatasetCount(getState()) - 1));
        }
      });
    });

    dispatch(viewReducer.updateType("datasets"));
    dispatch(viewReducer.updateDatasetViewMode("LIST"));
  };
}

export default overviewReducer;
